import { SortDirection } from "@angular/material/sort";

export const USER_SELECT_FIELDS: string[] = [
    'id',
    'displayName',
    'businessPhones',
    'mail',
    'userPrincipalName',
    'jobTitle',
    'department',
    'mobilePhone',
    'employeeId'
];

export const DEFAULT_ORDER_BY = 'displayName';
export const DEFAULT_ORDER_DIRECTION: SortDirection = 'asc';
export const DEFAULT_TOP = 20;